module.exports = __webpack_public_path__ + "img/logo.0ae0fb86.svg";